export const CREATE_MODAL_QUERY_KEY = 'is_create_modal_open';

export const QUICK_ADD_MODAL_QUERY_KEY = 'is_quick_add_modal_open';
export const QUICK_ADD_CLIENT_ID_QUERY_KEY = 'quick_add_client_id';
export const QUICK_ADD_FROM_AIR_REQUEST_QUERY_KEY = 'quick_add_from_air_request';

export const CLIENTS_DASHBOARD_QUERY_KEY = 'clients-dashboard-v3';

export const EXPORT_ALL_MAX_CLIENTS = 5000;

export const CLIENTS_LIST_PAGE_QUERY_KEY = 'clients_page';
export const CLIENTS_LIST_PER_PAGE_QUERY_KEY = 'clients_per_page';
export const CLIENTS_LIST_SORT_QUERY_KEY = 'clients_sort';
export const CLIENTS_LIST_SORT_LOCAL_STORAGE_KEY = 'clients-list-sort';
export const CLIENTS_LIST_STATUS_QUERY_KEY = 'clients_status';
export const CLIENTS_LIST_AGENT_QUERY_KEY = 'clients_agent';
export const CLIENTS_LIST_SEARCH_QUERY_KEY = 'clients_q';

export const CLIENTS_IMPORT_FILE_ACCEPT =
  '.csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel';

export const CLIENTS_IMPORT_CSV_ONLY = {
  accept: '.csv,text/csv',
  extensions: ['csv'],
  label: 'CSV',
};
